module.exports = __webpack_public_path__ + "static/img/ios.ddd27d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/ios.png
// module id = ERbH
// module chunks = 13